var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstMatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 178,
    viewBox: "0 0 137 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Bronze Medal",
    filter: "url(#filter0_d_3333_31315)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12",
    d: "M50.9609 98.6758L67.4457 108.193L33.9704 166.174L24.3623 144.746L50.9609 98.6758Z",
    fill: "#AA75CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 13",
    d: "M50.9609 98.6758L34.4761 89.1583L1.0008 147.139L24.3623 144.746L50.9609 98.6758Z",
    fill: "#73488D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14",
    d: "M74.4785 98.6758L57.9937 108.193L91.4691 166.174L101.077 144.746L74.4785 98.6758Z",
    fill: "#73488D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15",
    d: "M74.4785 98.6758L90.9633 89.1583L124.439 147.139L101.077 144.746L74.4785 98.6758Z",
    fill: "#AA75CB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 62.6934,
    cy: 58.7539,
    r: 57.2539,
    fill: "#DC9E42",
    stroke: "#774700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 62.6922,
    cy: 58.7547,
    r: 44.3016,
    fill: "#734C12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_31315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19,
    width: 90,
    height: 89
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 65.057,
    cy: 63.4828,
    r: 44.4047,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_31315)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 62.6918,
    cy: 58.7523,
    r: 44.4047,
    fill: "#A36D1D"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.9315 27.8633L72.5102 47.0207L91.6676 49.4154L78.5129 64.1666L82.0889 85.3356L62.9315 75.7569L43.774 85.3356L47.382 64.1666L34.1953 49.4154L53.3528 47.0207L62.9315 27.8633Z",
    fill: "url(#paint0_linear_3333_31315)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3333_31315",
    x: 0.216502,
    y: 0.216502,
    width: 135.975,
    height: 177.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3333_31315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3333_31315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_31315",
    x1: 62.9315,
    y1: 27.8633,
    x2: 62.9315,
    y2: 85.3356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FDE870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC759"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMatched);
export default __webpack_public_path__ + "static/media/First_Matched.c5b91996b1664c5417d819a6ed2e4b39.svg";
export { ForwardRef as ReactComponent };